// extracted by mini-css-extract-plugin
export default {"viewMore":"viewMore__MjY2Y","overflow":"overflow__YjQ2Y","more":"more__Mjc2Z","fade":"fade__OTYzZ","button":"button__YWE4N","less":"less__MmIzN","open":"open__ZjUwM"};